/* ===========================================================================
   Releasit COD — Método de envío por PROVINCIA (Argentina) — SereniVida
   ---------------------------------------------------------------------------
   Cuando el cliente elige una provincia, deja visible SOLO la opción de envío
   con el precio de la zona correspondiente y oculta las demás. Además, si la
   opción seleccionada quedó oculta, selecciona la correcta (click) para que el
   total de Releasit quede bien.

   DOM (confirmado):
     Provincia:  #_rsi-field-province_country_field  (<select>)
     Opciones:   ._rsi-modal-shipping-rates-item
     Precio:     ._rsi-modal-checkout-line-price   (ej "$5.999")

   Mapa por PRECIO (fuente: tabla de zonas):
     Zona 1 $5.999  | Zona 2 $7.999 | Zona 3 $10.999 | Zona 4 $14.999

   FAIL-OPEN: si la zona no tiene su precio disponible entre las opciones, se
   muestran TODAS (nunca se rompe la posibilidad de pagar).
   =========================================================================== */
(function () {
  'use strict';

  var PROVINCE_SEL = '#_rsi-field-province_country_field';
  var RATE_ITEM    = '._rsi-modal-shipping-rates-item';
  var RATE_PRICE   = '._rsi-modal-checkout-line-price';

  // provincia (valor exacto del <option>) -> precio objetivo (solo enteros)
  var ZONE_PRICE = {
    // Zona 1 — $5.999
    'CIUDAD AUTONOMA DE BUENOS AIRES': '5999',
    'BUENOS AIRES': '5999',
    // Zona 2 — $7.999
    'CORDOBA': '7999', 'SANTA FE': '7999', 'MENDOZA': '7999', 'ENTRE RIOS': '7999',
    'TUCUMAN': '7999', 'SALTA': '7999', 'LA PAMPA': '7999', 'CHACO': '7999',
    'CORRIENTES': '7999', 'MISIONES': '7999', 'SANTIAGO DEL ESTERO': '7999', 'CATAMARCA': '7999',
    // Zona 3 — $10.999
    'RIO NEGRO': '10999', 'NEUQUEN': '10999', 'CHUBUT': '10999', 'SAN JUAN': '10999',
    'SAN LUIS': '10999', 'JUJUY': '10999', 'FORMOSA': '10999', 'LA RIOJA': '10999',
    // Zona 4 — $14.999
    'TIERRA DEL FUEGO': '14999', 'SANTA CRUZ': '14999'
  };

  function norm(s){ return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().toUpperCase(); }
  // toma la parte entera (antes de la coma de centavos) y deja solo dígitos: "$5.999,00" -> "5999"
  function priceInt(s){ return (String(s == null ? '' : s).split(',')[0].match(/\d+/g) || []).join(''); }

  function getProvince(){
    var el = document.querySelector(PROVINCE_SEL);
    return el ? norm(el.value) : '';
  }
  function priceOf(item){
    var p = item.querySelector(RATE_PRICE);
    return p ? priceInt(p.textContent) : '';
  }
  function showAll(items){
    for (var i = 0; i < items.length; i++) items[i].style.removeProperty('display');
  }

  var applying = false;

  function apply(){
    if (applying) return;

    var items = document.querySelectorAll(RATE_ITEM);
    if (!items.length) return;

    var prov   = getProvince();
    var target = ZONE_PRICE[prov] || null;

    // sin provincia elegida o zona desconocida -> no filtrar
    if (!target) { showAll(items); return; }

    var matching = [];
    for (var i = 0; i < items.length; i++) {
      if (priceOf(items[i]) === target) matching.push(items[i]);
    }

    // la zona no tiene su precio entre las opciones disponibles -> fail-open
    if (!matching.length) { showAll(items); return; }

    applying = true;
    try {
      for (var j = 0; j < items.length; j++) {
        var keep = matching.indexOf(items[j]) !== -1;
        items[j].style.setProperty('display', keep ? '' : 'none', 'important');
      }

      // si la opción seleccionada quedó oculta, seleccionar una visible correcta
      var selectedVisible = false;
      for (var k = 0; k < matching.length; k++) {
        if (matching[k].getAttribute('data-selected') === 'true') { selectedVisible = true; break; }
      }
      if (!selectedVisible) {
        try { matching[0].click(); } catch (e) {}
      }
    } finally {
      applying = false;
    }
  }

  // re-aplicar con debounce ante: cambio de provincia, recálculo de Shopify y re-render del modal
  var t = null;
  function schedule(){ if (t) clearTimeout(t); t = setTimeout(apply, 120); }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches(PROVINCE_SEL)) schedule();
  }, true);

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
